import script from "./topicPressDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./topicPressDialog.vue?vue&type=script&setup=true&lang=js"

import "./topicPressDialog.vue?vue&type=style&index=0&id=3ecbf93b&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ecbf93b"]])

export default __exports__